* HTML document, ASCII text, with CRLF line terminators
<template>
	<div>
		<loading v-bind:dspin="!loaded"></loading>
		<div v-if="loaded" v-bind:class="cls1">
			<!-- CONTENT START -->
			<div class="dispatch w3-table">
				<div v-for="each in statuses" :id="each.status+'_'+each.rank" class="status"
				     v-on:drop="onDrop(each.status+'_'+each.rank, $event)"
				     v-on:dragover='onDragOver($event)'>
					<statusColumn :status="each"
					              :appointments="getAppointmentsForStatus(each.status)"
					              :statuses="statuses"
					              :plugin="plugin"
					              :groups="groups"
					              :checkNotifications="checkNotifications">
					</statusColumn>
				</div>
			</div>

			<!--RIGHT CONTENT STARTS HERE = PATIENT INFO + NEW PATIENT -->
			<div v-if="openPatientCard"
			     class="w3-col content-sidebar-right top-from-header w3-animate-right flow-padding-top">
				<patient-side-card class="flow-padding-top"
				                   :selectedPatient="selectedPatient"
				                   :selectedPatientStatus="selectedPatient.status"
				                   :selectedPatientDevice="selectedPatient.device"
				                   :onClose="() => {openPatientCard = false; activePatientId = undefined}">
				</patient-side-card>
			</div>
			<!-- CONTENT END -->
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import {EventBus} from "@/main";
import ContentHeader from "@/components/common/ContentHeader";
import Loading from "@/components/common/Loading";
import StatusColumn from "@/components/status-overview/mi/statusColumn.vue";
import PatientSideCard from "@/components/patient/PatientSideCard";

const frc = Vue.prototype.$frc;

export default {
	name: "Dispatch",
	components: {ContentHeader, Loading, StatusColumn, PatientSideCard},
	props: ['ftitle', 'selectedGroup', 'groups'],
	data: function () {
		return {
			subscriptions: 'SUBSCRIPTIONS',
			waiting: 'WAITING',
			loaded: false,
			openPatientCard: false,
			selectedPatient: {},
			activePatientId: undefined,
			refreshIntervalId: undefined,
			statuses: [],
			draggedAppointment: undefined,
			serverTime: undefined,
			refreshServerTime: undefined,
			plugin: '',
			lsMap: {},
			checkupTypes: [],
			appointmentsForStatus: {},
			targetCard: {}
		}
	},
	beforeDestroy() {
		EventBus.$off("patientSelected" + this.plugin, this.openPatientDetail);
		EventBus.$off("droppedOnCard");
		EventBus.$off("dragStarted" + this.plugin, this.startDrag);
		EventBus.$off("forwardPushed" + this.plugin, this.forwardPatient);
		EventBus.$off("patientUpdated" + this.plugin, this.updateStatus);
		clearInterval(this.refreshIntervalId);
		// clearInterval(this.refreshServerTime);
	},
	mounted() {
		this.getCheckupTypesInSelectedGroup();
		EventBus.$on("patientSelected" + this.plugin, this.openPatientDetail);
		EventBus.$on("droppedOnCard", (targetCard) => {
			this.targetCard = targetCard;
		});
		EventBus.$on("dragStarted" + this.plugin, this.startDrag);
		EventBus.$on("forwardPushed" + this.plugin, this.forwardPatient);
		EventBus.$on("patientUpdated" + this.plugin, this.updateStatus);
		this.refreshIntervalId = setInterval(this.refreshPatients, 5000);
		// this.refreshServerTime = setInterval(this.getServerTime, 40000);
		// this.getServerTime();
	},
	created() {
		this.plugin = Vue.prototype.$currentWard.uisettings.plugin;
	},
	watch: {
		selectedGroup() {
			this.statuses = [];
			this.appointmentsForStatus = {};
			this.getCheckupTypesInSelectedGroup();
		},
		checkupTypes(newTypes) {
			let statusRank = 1;
			this.statuses = [
				{"status": this.subscriptions, "rank": statusRank++},
				{"status": this.waiting, "rank": statusRank++},
			];
			if (!newTypes) {
				return;
			}

			for (let i in newTypes) {
				this.statuses.push({"status": newTypes[i], "rank": statusRank++});
			}

			this.appointmentsForStatus = {};
			for (let j in this.statuses) {
				let st = this.statuses[j];
				this.appointmentsForStatus[st.status] = [];
			}

			this.getAppointments();
		}
	},
	computed: {
		isCardOpen() {
			return this.openPatientCard;
		},
		cls0() {
			if (!this.isCardOpen) return 'flow-margin-right';

			return 'content-sidebar-header ' + (this.openPatientAlerts ? 'sidebars-70-30' : 'sidebars-50-50');
		},
		cls1() {
			if (!this.isCardOpen) return '';

			return 'content-sidebars ' + (this.openPatientAlerts ? 'sidebars-70-30' : 'sidebars-50-50');
		}

	},
	methods: {
		getCheckupTypesInSelectedGroup() {
			if (!this.selectedGroup) {
				return;
			}
			let app = this;
			let wardId = Vue.prototype.$currentWard.id;
			frc.getCheckupTypesInGroup(wardId, app.selectedGroup).then(function (res) {
				app.checkupTypes = res.data;
			});
		},
		getServerTime() {
			let app = this;
			frc.getServerTime().then(function (res) {
				app.serverTime = res.data;
			}).catch(function (ex) {
				console.log(ex);
			})
		},
		refreshPatients() {
			this.getAppointments();
		},
		openPatientDetail(patient) {
			this.openPatientCard = true;
			this.selectedPatient = patient;
			this.activePatientId = patient.id;
		},
		getAppointments: function () {
			const wardId = Vue.prototype.$currentWard.id;
			const app = this;
			frc.getPatientsForWard(wardId, null, [app.selectedGroup], null).then(function (res) {
				let appointments = res.data;
				let appointmentPerStatus_ = {};
				for (let i in app.statuses) {
					appointmentPerStatus_[app.statuses[i].status] = [];
				}

				for (let i in appointments) {
					let appointment = appointments[i];
					let checkups_ = appointment.checkups;
					let checkupNo = 3;
					for (let i in checkups_) {
						checkups_[i].rank = checkupNo++;
					}

					if (app.isStatusLeftConsultation(appointment.status)) {
						continue;
					}
					if (app.isStatusAtWaitingArea(appointment.status) || app.isStatusLeftWaitingArea(appointment.status)) {
						appointmentPerStatus_[app.waiting].push(appointment);
					} else if (app.isStatusNoBadge(appointment.status) || app.isStatusOnTheWay(appointment.status)) {
						let subsArray = appointmentPerStatus_[app.subscriptions];
						subsArray.push(appointment);
					} else {
						let checkups = appointment.checkups;
						let addedDressing = false;
						for (let ic in checkups) {
							let checkup = checkups[ic];
							if (app.isConsultation(checkup.type)
									|| (app.isExamination(checkup.type) && app.isStarted(checkup.status))
									|| (!addedDressing && (addedDressing = app.isDressing(checkup.type)))) {
								appointmentPerStatus_[checkup.type].push(appointment);
							}
						}
					}
				}
				let waitingAppo = appointmentPerStatus_[app.waiting];
				// assign an index to waiting appointments for sorting
				if (waitingAppo) {
					waitingAppo.forEach(function (item, index) {
						item['index'] = index;
					})
				}

				app.appointmentsForStatus = appointmentPerStatus_;
			}).finally(function () {
				app.loaded = true;
			});
		},
		getAppointmentsForStatus(status) {
			return this.appointmentsForStatus[status];
		},
		checkNotifications() {
			let items = localStorage.getItem("notifyAppointments" + this.plugin);
			let lsitems = {};
			let statuses = this.statuses;
			let notify = false;
			if (items) {
				lsitems = JSON.parse(items);
				for (let i = 0; i < statuses.length; i++) {
					let appointments = lsitems[statuses[i].status + statuses[i].rank];
					if (appointments.length > 0) {
						notify = true;
					}
				}
				EventBus.$emit("checkNotifications", notify); // for showing generic bell notification
			}
		},
		checkInArray(id, old) {
			let match = false;
			for (let i = 0; i < old.length; i++) {
				if (old[i].appointmentId === id) {
					match = true;
					break;
				}
			}
			return match;
		},
		startDrag(appointment) {
			this.draggedAppointment = appointment;
		},
		onDragOver: function (event) {
			event.preventDefault();
		},
		onDrop(targetStatus, event) {
			let app = this;
			let patient = app.draggedAppointment.appointment;
			if (app.draggedAppointment.draggable === true) {
				app.disableForward(app.draggedAppointment);
				let draggedAppStatus = app.draggedAppointment ? app.draggedAppointment.status.status + '_' + app.draggedAppointment.status.rank : null;

				if (draggedAppStatus) {
					if (draggedAppStatus === targetStatus) {
						if (app.isWaiting(app.draggedAppointment.status.status)) {
							// If dropped on another card in Waiting status then move card there
							if (app.targetCard.appointment) {
								let waitingAppointments = app.appointmentsForStatus[app.waiting];
								let targetIndex = app.targetCard.appointment.index
								let startIndex = app.draggedAppointment.appointment.index;
								let lsWItems = JSON.parse(localStorage.getItem("waitingAppointments"));

								app.arrayMove(waitingAppointments, startIndex, targetIndex);

								for (let i = 0, appointments = Object.keys(lsWItems), ii = appointments.length; i < ii; i++) {
									let appo = appointments[i];
									let index = lsWItems[appo];
									if (targetIndex < startIndex) {
										if (index >= targetIndex && index < startIndex) {
											lsWItems[appo] = index + 1;
										}
									} else if (targetIndex > startIndex) {
										if (index <= targetIndex && index > startIndex) {
											lsWItems[appo] = index - 1;
										}
									}
								}

								lsWItems[app.draggedAppointment.appointment.appointmentId] = targetIndex;
								localStorage.setItem("waitingAppointments", JSON.stringify(lsWItems));
								localStorage.setItem("sortWaiting", 'true');

							} else {
								Vue.notifyError({message: app.$t("dropOnCard")});
							}
						}
						app.enableForward(app.draggedAppointment);
					} else {
						app.disableForward(app.draggedAppointment);
						frc.startNextCheckup(patient.patientId, patient.appointmentId).then().finally(function () {
							app.refreshPatients();
							app.enableForward(app.draggedAppointment);
						});
					}
				}

				event.dataTransfer.clearData();

				app.targetCard = {};
			}

		},
		arrayMove(arr, fromIndex, toIndex) {
			let element = arr[fromIndex];
			arr.splice(fromIndex, 1);
			arr.splice(toIndex, 0, element);
		},
		forwardPatient: function (appo) {
			let app = this;
			let patient = appo.appointment
			app.disableForward(appo);
			frc.startNextCheckup(patient.patientId, patient.appointmentId).then().finally(function () {
				app.refreshPatients();
				app.enableForward(appo);
				Vue.prototype.$forwardedAppointment = {"patient": patient, "status": appo.status};
			});
		}
		,
		enableForward(appo) {
			let patient = appo.appointment;
			let status = appo.status;
			if (document.getElementById(patient.appointmentId + "_forward")) {
				document.getElementById(patient.appointmentId + "_forward").classList.remove
				('w3-hide');
			}
			document.getElementById(patient.appointmentId + '_' + status.rank).classList.remove('w3-disabled');
		}
		,
		disableForward(appo) {
			let patient = appo.appointment;
			let status = appo.status;
			if (document.getElementById(patient.appointmentId + "_forward")) {
				document.getElementById(patient.appointmentId + "_forward").classList.add('w3-hide');
			}
			document.getElementById(patient.appointmentId + '_' + status.rank).classList.add('w3-disabled');
		}
		,
		updateStatus(patientId) {
			let app = this;
			frc.getPatientInWard(Vue.prototype.$currentWard.id, patientId).then(function (res) {
				if (!res.data) {
					console.log("Patient not found.");
					return;
				}
				app.selectedPatient.status = res.data.status;
			});
		}
	}
}
</script>

<style>
.dispatch {
	display: inline-flex;
}

.dispatch .status {
	border-right: 1px solid #ddd;
	padding: 0 10px;
	width: 20%;
	height: auto;
	overflow: hidden;
	min-height: 80vh;
}

.dispatch .status:last-of-type {
	border-right: none;
}

.dispatch .status.folded {
	width: 5%;
	overflow: visible;
	text-transform: uppercase;
	letter-spacing: 10px;
}

.dispatch .status.folded h1 {
	-webkit-transform: rotate(90deg);
	-moz-transform: rotate(90deg);
	-o-transform: rotate(90deg);
	transform: rotate(90deg);
}

.dispatch .status h1 i {
	padding-top: 5px;
}
</style>